<template>
  <layout>
    <div class="container mt-4">
      <div class="row">
        <div class="col-12">
          <b-card>
            <b-card-text>
              <h5 class="font-weight-bold">Appointments</h5>
            </b-card-text>

            <div
              v-if="!appointmentsLoaded"
              class="d-flex flex-row justify-content-center mt-4 mb-4"
            >
              <b-spinner
                style="width: 4rem; height: 4rem"
                variant="primary"
                label="Spinning"
              ></b-spinner>
            </div>

            <b-tabs v-if="appointmentsLoaded" card>
              <b-tab title="Upcoming" active>
                <appointment-card
                  v-for="(item, index) in appointmentsUpcomingLoaded"
                  :appointment="item"
                  :key="'au' + index"
                />

                <div
                  class="d-flex flex-row justify-content-center"
                  v-if="upcomingAppointments.length < 1"
                >
                  <p class="font-weight-bold" style="font-size:0.8em;">
                    NO UPCOMING APPOINTMENTS
                  </p>
                </div>

                <div
                  v-if="upcomingAppointments.length > maxUpcomingLoaded"
                  class="d-flex flex-row justify-content-center mt-4"
                >
                  <b-button
                    variant="outline-primary"
                    @click="maxUpcomingLoaded += 5"
                  >
                    Load More...
                  </b-button>
                </div>
              </b-tab>

              <b-tab title="Past">
                <appointment-card
                  v-for="(item, index) in appointmentsPastLoaded"
                  :appointment="item"
                  :key="'ap' + index"
                  global-mode="past"
                />

                <div
                  class="d-flex flex-row justify-content-center"
                  v-if="appointmentsPastLoaded.length < 1"
                >
                  <p class="font-weight-bold" style="font-size:0.8em;">
                    NO PAST APPOINTMENTS
                  </p>
                </div>

                <div
                  v-if="pastAppointments.length > maxPastLoaded"
                  class="d-flex flex-row justify-content-center mt-4"
                >
                  <b-button
                    variant="outline-primary"
                    @click="maxPastLoaded += 5"
                  >
                    Load More...
                  </b-button>
                </div>
              </b-tab>
              <b-tab title="Requests">
                <div class="d-flex justify-content-end">
                  <b-button
                    v-if="patientsCanSelfScheduleAppointments"
                    variant="primary"
                    @click="goToNewAppointmentRequest"
                  >
                    New
                  </b-button>
                </div>
                <appointment-request-card
                  v-for="(item, index) in appointmentRequests"
                  :appointment="item"
                  :key="'ap' + index"
                />
                <div
                  class="d-flex flex-row justify-content-center"
                  v-if="appointmentRequests.length < 1"
                >
                  <p class="font-weight-bold" style="font-size:0.8em;">
                    NO APPOINTMENTS REQUESTS
                  </p>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Layout from "../workspace/Layout.vue";
import AppointmentCard from "./AppointmentCard.vue";
import AppointmentRequestCard from "./AppointmentRequestCard.vue";
import signalAppointmentClient from "../../signalr/appointments.js";
import { appointmentsServer } from "../../server/appointments";

export default {
  name: "Appointments",
  components: {
    Layout,
    AppointmentCard,
    AppointmentRequestCard
  },
  data() {
    return {
      maxUpcomingLoaded: 5,
      maxPastLoaded: 5
    };
  },
  async mounted() {
    await this.loadCurrentLocation();
    await this.loadAppointmentRequests();
    await this.loadAppointments();
    signalAppointmentClient.initialize(
      "appointments",
      this.$store.state.session.systemSettings.signalRAppUrl
    );
    signalAppointmentClient.start();

    signalAppointmentClient.on("UpdatePortalAppAppointment", result => {
      if (result && result.tenantName === this.config.currentTenant) {
        const isUpcomingRenderedEvent = this.appointmentsUpcomingLoaded.find(
          appointment => appointment.id === result.scheduleEventId
        );
        const isPastRenderedEvent = this.appointmentsPastLoaded.find(
          appointment => appointment.id === result.scheduleEventId
        );

        if (isUpcomingRenderedEvent || isPastRenderedEvent) {
          this.loadAppointments();
        }
      }
    });
  },
  destroyed() {
    signalAppointmentClient.stop();
  },
  methods: {
    ...mapActions("session", ["loadCurrentLocation"]),
    ...mapActions("appointments", [
      "loadAppointmentRequests",
      "loadAppointments"
    ]),
    goToNewAppointmentRequest() {
      this.$router.replace({
        name: "AppointmentRequestAdd"
      });
    },
    async sendMessageToMainApp() {
      appointmentsServer.sendToPortal();
    }
  },
  computed: {
    ...mapGetters("appointments", [
      "appointments",
      "appointmentRequests",
      "upcomingAppointments",
      "pastAppointments",
      "appointmentsLoaded"
    ]),
    ...mapState("session", {
      config: state => state.systemSettings
    }),
    appointmentsUpcomingLoaded() {
      return this.upcomingAppointments.slice(0, this.maxUpcomingLoaded);
    },
    appointmentsPastLoaded() {
      return this.pastAppointments.slice(0, this.maxPastLoaded);
    },
    patientsCanSelfScheduleAppointments() {
      return this.config.appointmentRequestEnable ? true : false;
    }
  }
};
</script>

<style lang="scss">
.card-header {
  padding: 0 15px 12px;
  background-color: transparent;
  border: none;
}

.tab-pane {
  padding: 20px 0;
}
</style>
